/*
 *  Copyright (c) 2020. Legalbird eine Marke der R&S Internet Jewels GmbH
 */

import React from "react";
import Layout from "../../../containers/Layouts/Layout";
import CircularProgress from "@mui/material/CircularProgress";
import Container from "../../Container/Container";
import TextCard from "../../Cards/TextCard/TextCard";
import Grid from "@mui/material/Grid";
import { Navigate } from "react-router-dom";
import { getCaseLink, getProductData, getProductNameBy } from "../../../services/productService";
import { useQuery } from "@tanstack/react-query";
import { fetchResource, queryKeys } from "../../../services/reactQuery/reactQueryService";
import useProductParams from "../../../hooks/useProductParams";
import { Typography } from "@mui/material";
import { AbstractCase } from "../../../types/Entities/AbstractCase";

const CaseCompleteLoader = () => {
  const { productName, productId } = useProductParams();
  const productClassName = getProductNameBy("urlPartShort", productName);
  const productApiUri = getProductData(productClassName, "apiUri");
  const { data: product, isLoading } = useQuery(queryKeys.item(productApiUri, productId), () => fetchResource(productApiUri, productId));

  const getCaseCompletedLink = (product: AbstractCase) => {
    switch (product.name) {
      case "traffic":
        if (product.legalExpenseInsurance !== true) {
          return "/checkout?orderId=" + product.checkoutItem.id + "_" + product.id;
        }
        return getCaseLink(product);
      default:
        return getCaseLink(product);
    }
  };

  if (isLoading || !product.isCustomerDataCompleted) {
    return (
      <Layout>
        <Container>
          <TextCard boxHeading={"Ihr Fall wird angelegt..."} headingColor={"primary"} minHeadingHeight={70}>
            <Grid container justifyContent={"center"}>
              <Grid component={CircularProgress} item size={100} />
            </Grid>
            <Typography sx={{ textAlign: "center" }}>Dies dauert einen kurzen Moment.</Typography>
          </TextCard>
        </Container>
      </Layout>
    );
  }
  return <Navigate to={getCaseCompletedLink(product)} />;
};

export default CaseCompleteLoader;
